import type { AxiosPromise } from "axios";
import { AxiosApiWrapper } from "../../services/api/AxiosApiWrapper";
import { route } from "../../shim/jsbridge";
import { ParanoidModeConfig } from "./@types";

class Api extends AxiosApiWrapper {
  getParanoidModeConfig = (): AxiosPromise<ParanoidModeConfig> =>
    this.get(route("risk-tolerance-levels-config"));

  postParanoidModeConfig = (
    config: ParanoidModeConfig
  ): AxiosPromise<ParanoidModeConfig> =>
    this.post(route("risk-tolerance-levels-config-update"), config);
}

export default new Api();
